module.exports = __webpack_public_path__ + "json/market7-0.json?edafcc601781a0ef7d8a185487c742e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market7-0.json
// module id = 1268
// module chunks = 3